import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";

const PILLARS = [
  {
    n: "01",
    title: "God can handle our questions",
    body: "God\u2019s first recorded question to humanity is \u201cWhere are you?\u201d (Genesis 3:9). He already knew. He asked to draw a hiding heart back into the open\u2014and He still meets our questions the same way.",
  },
  {
    n: "02",
    title: "Questions are relationship",
    body: "To question the text, our leaders, and even God is not rebellion\u2014it is the language of intimacy. Curiosity is how love stays close.",
  },
  {
    n: "03",
    title: "Let the text speak",
    body: "We don't flatten Scripture into easy answers. We sit in its questions of wonder, lament, rebuke, and invitation, and let them shape us.",
  },
];

export default function About() {
  return (
    <div>
      <section className="mx-auto max-w-4xl px-4 py-16 text-center sm:px-6 lg:py-24">
      <Seo title="Why We Ask" description="Why QuestionGod exists: asking God is not rebellion, it is how intimacy grows." />
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-gold">Why We Ask</span>
        <h1 className="mt-4 font-serif text-4xl font-bold leading-[1.05] tracking-tight text-foreground sm:text-6xl">
          Curiosity breeds intimacy.
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-muted-foreground">
          The Question God Project challenges faith traditions that discourage questioning and aims to
          restore a childlike curiosity, wonder, and awe. To the notion of &ldquo;Don't question God,&rdquo;
          we say: God can not only handle our questions&mdash;He uses them as a door to relationship.
        </p>
      </section>

      <section className="border-y border-border bg-muted/40">
        <div className="mx-auto grid max-w-5xl grid-cols-1 gap-8 px-4 py-16 sm:px-6 md:grid-cols-3 lg:py-20">
          {PILLARS.map((p, i) => (
            <div key={p.n} style={{ animationDelay: `${i * 80}ms` }} className="qg-rise">
              <p className="font-mono text-sm font-bold text-gold">{p.n}</p>
              <h3 className="mt-3 font-serif text-2xl font-semibold text-foreground">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{p.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-4 py-16 text-center sm:px-6 lg:py-24">
        <blockquote className="font-serif text-3xl font-medium italic leading-tight text-foreground sm:text-4xl">
          &ldquo;Asking God isn't rebellion. It's relationship.&rdquo;
        </blockquote>
        <p className="mt-8 text-muted-foreground">
          In order to have true relationship with God, we have to be willing and able to ask Him
          questions&mdash;to study the Word, and to stay curious.
        </p>
        <Link to="/explore">
          <Button className="mt-8 rounded-full bg-primary px-8 py-6 text-base text-primary-foreground hover:bg-primary/90">
            Begin exploring <ArrowRight className="ml-1 h-4 w-4" />
          </Button>
        </Link>
      </section>
    </div>
  );
}
